// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"chevron-down"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M17.5 9.5L12 15L6.5 9.5","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ChevronDownIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'chevron-down',
    ref,
    icon: element,
  },
));

ChevronDownIcon.displayName = 'ChevronDownIcon';

export default ChevronDownIcon;
